class KeshRugColourCard extends HTMLElement {
  connectedCallback() {
    this.buttons = [...this.querySelectorAll('[data-image-index]')];
    this.images = [...this.querySelectorAll('[data-colour-image]')];
    this.productLinks = [...this.querySelectorAll('.kr-product-card__main')];
    this.buttons.forEach((button) => button.addEventListener('click', () => this.select(Number(button.dataset.imageIndex))));
  }

  select(index) {
    this.images.forEach((image, imageIndex) => image.classList.toggle('is-active', imageIndex === index));
    this.buttons.forEach((button, buttonIndex) => {
      button.classList.toggle('is-active', buttonIndex === index);
      button.setAttribute('aria-pressed', String(buttonIndex === index));
    });
    const variantUrl = this.buttons[index]?.dataset.variantUrl;
    if (variantUrl) this.productLinks.forEach((link) => link.setAttribute('href', variantUrl));
  }
}

if (!customElements.get('kr-colour-card')) customElements.define('kr-colour-card', KeshRugColourCard);
